export const soTypesInput = [
    {name:'Dispatch',value:'Dispatch'},{name : 'Stock',value:'Stock'}
]